import { del, get, post } from "../backend"
import type { User } from "./authStore"




export interface LoginState<T> {
  authenticated: boolean
  user: T
}

export function loginState<T>() {
  return get<LoginState<T>>("accounts/login/")
}

export interface LoginResponse<T> {
  authenticated: boolean
  user: T
}

export function loginWithPassword<T>(body: {
  username: string
  password: string
}) {
  return post<LoginResponse<T>>("accounts/login/", body)
}

export function loginWithGoogle<T>(body: { id_token: string }) {
  return post<LoginResponse<T>>("accounts/google-login/", body)
}

export function doLogout() {
  return get("accounts/logout/")
}

export interface CheckUserResponse {
  result: ("unknown" | "webauthn" | "password" | "google")[]
}

export function postCheckUser(body: { username: string }) {
  return post<CheckUserResponse>("accounts/check-user/", body)
}

// WebAuthn

export function startWebAuthnLogin(body: { username: string }) {
  return post<any>("webauthn/api/start-auth/", body)
}

export function webAuthnAuthenticate(body: any) {
  return post<any>("webauthn/api/auth/", body)
}

export function webAuthnStartRegistration(body: { username: string }) {
  return post<any>("webauthn/api/start-registration/", body)
}

export function startWebAuthnAddition(body: {
  username: string
  code: string
}) {
  return post<any>("webauthn/api/new-device/start-add/", body)
}

export function webAuthnFinishRegistration(body: any) {
  return post<any>("webauthn/api/register/", body)
}

export interface WebAuthnCred {
  created: string
  id: string
  current_session: boolean
}

export interface WebAuthnCredsResponse {
  creds: WebAuthnCred[]
}

export function getWebAuthnCreds() {
  return get<WebAuthnCredsResponse>("webauthn/api/creds/")
}

export function getWebAuthnNewDeviceCode() {
  return get<{ code: string | null }>("webauthn/api/new-device/")
}

export function deleteWebAuthnCred(id: string) {
  return del(`webauthn/api/creds/${id}/`)
}

export function startWebAuthnNewDevice() {
  return post<{ code: string }>("webauthn/api/new-device/", {})
}

export function deleteWebAuthnNewDeviceCode() {
  return del("webauthn/api/new-device/")
}

// Account edit

export interface AccountInfo {
  google_linked: boolean
  password_set: boolean
}

export function getAccountInfo() {
  return get<AccountInfo>("accounts/get-account/")
}

export interface ChangePasswordRequest {
  current_password: string
  new_password_1: string
  new_password_2: string
}

export function changePassword(request: ChangePasswordRequest) {
  return post<{ success: boolean }>("accounts/changepassword/", request)
}

export function changeEmail(body: { new_email: string }) {
  return post("accounts/changeemail/", body)
}

export function postChangeUsername(body: { new_username: string }) {
  return post<{ success: boolean }>("accounts/changeusername/", body)
}

export function postUnlinkGoogle() {
  return post<{ success: boolean }>("accounts/unlinkgoogle/", {})
}

export function postDeleteAccount(body: { username: string }) {
  return post<{ success: boolean }>("accounts/deleteaccount/", body)
}
